<template>
	<div class="content">
		<van-row v-for="ip in data" :key="ip.id">
			<van-col span="12">{{ ip.ip }}</van-col>
			<van-col span="12">{{ new Date(ip.time).toLocaleString() }}</van-col>
		</van-row>
	</div>
</template>

<script>
import {
	getIpSaveList
} from '../util/api'
export default {
	name: 'IpList',
	data() {
		return {
			data: [],
		}
	},
	methods: {
		getIpSaveList: function () {
			getIpSaveList().then((res) => {
				this.data = res.data
			})
		}
	},
	mounted() {
		this.getIpSaveList();
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.content {
	padding: 12px 24px 0;
	display: flex;
	flex-direction: column;
	height: 100%;
	box-sizing: border-box;
	gap: 12px;
}
</style>
